import { useTranslation } from 'react-i18next'
import { Label } from '@/components/shadcn/label'
import { Checkbox } from '@/components/shadcn/checkbox'
import { useGetApiCompaniesCurrentGroups } from '@/api/generated/company-management-user/company-management-user'
import { LoaderGeneral } from '@/components/common/loaders/LoaderGeneral'

interface Props {
  visibleGroups: number[]
  onChange: (newVisibleGroups: number[]) => void
  disabled?: boolean
}

/** Three-option radio for the visibility of yearly events (birthdays/anniversaries). */
export function GroupsVisibilityPicker({ visibleGroups, onChange, disabled }: Props) {
  const { data, isLoading, isError } = useGetApiCompaniesCurrentGroups();
  const groups = data?.data;

  const { t } = useTranslation('service-modules-calendar')
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm font-medium">{t("visibleGroupsTitle")}</p>
      <LoaderGeneral
        isLoading={isLoading}
        isError={isError}
        isEmpty={groups ? groups.length == 0 : undefined}
      />
      {groups && groups.map((group) => {
        const id = "group-visiblility-" + group.id;

        return (
          <div key={id} className="flex items-center gap-2">
            <Checkbox
              disabled={disabled}
              id={id}
              checked={visibleGroups.indexOf(group.id) >= 0} onCheckedChange={(v) => {
                if (v === true) {
                  onChange([
                    ...new Set([
                      ...visibleGroups,
                      group.id
                    ])
                  ])
                } else {
                  onChange(visibleGroups.filter((g) => g != group.id))
                }
              }} />
            <Label htmlFor={id} className="font-normal">
              {group.name}
            </Label>
          </div>
        )
      })}
    </div>
  )
}
